import { EMPTY_VALUE, DEFAULT_VALUE, } from '@wix/form-fields';
export const fillEmptyValues = (form, values, recursive = true) => {
    if (!form?.fields) {
        return {};
    }
    return form.fields.reduce((result, field) => {
        const fieldTarget = field.target;
        if (!fieldTarget) {
            return result;
        }
        const fieldValue = values?.[fieldTarget];
        const defaultValue = field.view?.defaultValue;
        const fieldType = field.view?.fieldType;
        const nestedForm = field.view?.form;
        if (recursive && nestedForm) {
            result[fieldTarget] = fillEmptyValues(nestedForm, fieldValue, false);
        }
        else if (fieldValue !== undefined) {
            result[fieldTarget] = fieldValue;
        }
        else if (defaultValue !== undefined) {
            result[fieldTarget] = DEFAULT_VALUE[fieldType]?.(field);
        }
        else if (fieldType) {
            result[fieldTarget] = EMPTY_VALUE;
        }
        return result;
    }, {});
};
//# sourceMappingURL=form-values.js.map